import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import SiteFooter from "@/components/SiteFooter";
import TermlyEmbed from "@/components/TermlyEmbed";

const TERMLY_PRIVACY_ID = "0e952119-578f-4aa9-9900-4da790ea731e";

export default function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-foreground/30 glass-strong sticky top-0 z-40">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <ThemeToggle />
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24 w-full" data-testid="privacy-page">
        <div className="terminal-label mb-4">[ LEGAL · PRIVACY ]</div>
        <div className="legal-body">
          <TermlyEmbed dataId={TERMLY_PRIVACY_ID} testid="privacy-termly-embed" />
        </div>
      </main>

      <SiteFooter variant="site" />
    </div>
  );
}
